import React from 'react';

const Contact: React.FC = () => {
    return (
        <div className="container">
            <h1 className="text-center mb-4">📞 Contact Us</h1>
            <p className="text-center mb-5">Get in touch with Uma Shankar Security Agency for professional security and manpower solutions</p>
            
            <div className="row">
                <div className="col-lg-6 mb-4">
                    <div className="card h-100 border-success">
                        <div className="card-header bg-success text-white">
                            <h4>🛡️ Uma Shankar Security Agency</h4>
                        </div>
                        <div className="card-body">
                            <div className="mb-3">
                                <h5 className="text-success">📧 Email</h5>
                                <p>info.usecurityagency@gmail.com<br />contact.usecurityagency@gmail.com</p>
                            </div>
                            <div className="mb-3">
                                <h5 className="text-success">📱 Phone</h5>
                                <p>+91 94538 40107<br />+91 74154 05250 (Emergency)</p>
                            </div>
                            <div className="mb-3">
                                <h5 className="text-success">📍 Address</h5>
                                <p>Uma Shankar Security Agency<br />India</p>
                            </div>
                            <div className="mb-3">
                                <h5 className="text-success">👨✈️ Properitor</h5>
                                <p>Lt. Col. Uma Shankar (Retd)<br />Proprietor</p>
                            </div>
                        </div>
                    </div>
                </div>
                
                <div className="col-lg-6">
                    <div className="card">
                        <div className="card-header bg-primary text-white">
                            <h4>Send us a Message</h4>
                        </div>
                        <div className="card-body">
                            <form>
                                <div className="mb-3">
                                    <label htmlFor="name" className="form-label">Full Name *</label>
                                    <input type="text" className="form-control" id="name" name="name" required />
                                </div>
                                <div className="mb-3">
                                    <label htmlFor="email" className="form-label">Email Address *</label>
                                    <input type="email" className="form-control" id="email" name="email" required />
                                </div>
                                <div className="mb-3">
                                    <label htmlFor="phone" className="form-label">Phone Number</label>
                                    <input type="tel" className="form-control" id="phone" name="phone" />
                                </div>
                                <div className="mb-3">
                                    <label htmlFor="service" className="form-label">Service Required</label>
                                    <select className="form-select" id="service" name="service">
                                        <option value="">Select Service</option>
                                        <option value="security-guard">Security Guard Services</option>
                                        <option value="armed-security">Armed Security</option>
                                        <option value="manpower">Manpower Solutions</option>
                                        <option value="event-security">Event Security</option>
                                        <option value="other">Other</option>
                                    </select>
                                </div>
                                <div className="mb-3">
                                    <label htmlFor="message" className="form-label">Message *</label>
                                    <textarea className="form-control" id="message" name="message" rows={5} required></textarea>
                                </div>
                                <button type="submit" className="btn btn-success w-100">Send Message 📤</button>
                            </form>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Contact;